import React from "react";
import { Outlet, Link, withRouter, useHistory } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import GlobalBody from "../components/GlobalBody";
function Global() {
  return (
    <div>
      <Header />
      <GlobalBody />
      <Footer />
    </div>
  );
}
export default withRouter(Global);
